import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
} from "@north-beam/nb-common";

export const LEGACY_PLATFORMS = enumeratedLiterals(
  ["hyros", "triple-whale", "rockerbox", "wickedreports"] as const,
  {
    getLabels: (a) =>
      ({
        [a.HYROS]: "Hyros",
        [a.TRIPLE_WHALE]: "Triple Whale",
        [a.ROCKERBOX]: "Rockerbox",
        [a.WICKEDREPORTS]: "WickedReports",
      } as const),
  },
);

export type LegacyPlatform = EnumeratedLiteralType<typeof LEGACY_PLATFORMS>;
